// @ts-nocheck
import { motion } from 'framer-motion';

interface TVScreenProps {
    show: boolean;
}

export default function TVScreen({ show }: TVScreenProps) {
    return (
        <motion.div
            className="absolute flex items-center justify-center"
            initial={{ opacity: 0, scale: 0 }}
            animate={show ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0 }}
            transition={{
                duration: 0.8,
                ease: 'easeOut',
                delay: show ? 0.2 : 0,
            }}
            style={{
                position: 'absolute',
                top: '4%',
                left: '-32%',
                transform: 'translate(-50%, -50%)',
                width: '320px',
                height: '180px', // 16:9 aspect ratio (320/16*9 = 180)
                zIndex: 5,
            }}
        >
            {/* TV Frame */}
            <svg
                viewBox="0 0 320 180"
                className="absolute inset-0 w-full h-full"
                style={{
                    filter: 'drop-shadow(0 10px 30px rgba(0, 0, 0, 0.5))',
                }}
            >
                {/* Outer TV frame */}
                <rect
                    x="0"
                    y="0"
                    width="320"
                    height="180"
                    rx="20"
                    fill="#1a1a1a"
                    stroke="#333"
                    strokeWidth="2"
                />

                {/* Screen bezel */}
                <rect
                    x="10"
                    y="10"
                    width="300"
                    height="160"
                    rx="10"
                    fill="#000"
                    stroke="#222"
                    strokeWidth="1"
                />

                {/* Screen area (where logo will show) */}
                <rect
                    x="20"
                    y="20"
                    width="280"
                    height="140"
                    rx="5"
                    fill="transparent"
                    className="tv-screen-area"
                />

                {/* TV stand */}
                <rect x="140" y="180" width="40" height="15" fill="#1a1a1a" />
                <rect
                    x="120"
                    y="190"
                    width="80"
                    height="8"
                    rx="4"
                    fill="#1a1a1a"
                />

                {/* Power light */}
                <motion.circle
                    cx="160"
                    cy="170"
                    r="3"
                    fill="#00ff00"
                    animate={{ opacity: [0.5, 1, 0.5] }}
                    transition={{ duration: 2, repeat: Infinity }}
                />

                {/* Screen reflection */}
                <rect
                    x="20"
                    y="20"
                    width="280"
                    height="140"
                    rx="5"
                    fill="url(#screenGradient)"
                    opacity="0.1"
                />

                <defs>
                    <linearGradient
                        id="screenGradient"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                    >
                        <stop offset="0%" stopColor="white" stopOpacity="0.2" />
                        <stop offset="100%" stopColor="white" stopOpacity="0" />
                    </linearGradient>
                </defs>
            </svg>
        </motion.div>
    );
}
